"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TickIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "16",
  height: "14",
  viewBox: "0 0 16 14",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-1314.000000, -240.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(1315.000000, 241.000000)",
        fill: color,
        fillRule: "nonzero",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M13.2525044,-0.664266745 C13.6193688,-1.07709717 14.2514363,-1.11436001 14.6642667,-0.747495613 C15.045341,-0.408851557 15.106405,0.155764408 14.8249958,0.565326903 L14.7474956,0.664266745 L4.08361905,12.6642667 C3.71418932,13.0799839 3.08467313,13.1096266 2.67814936,12.7532359 L2.58851451,12.6641392 L-0.747608932,8.90872821 C-1.11440289,8.49583519 -1.07703222,7.86377402 -0.664139206,7.49698007 C-0.283007195,7.15840103 0.28487165,7.16419896 0.658475786,7.49184591 L0.747608932,7.58044979 L3.336,10.494 L13.2525044,-0.664266745 Z"
        })
      })
    })
  })]
});

TickIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = TickIcon;
exports.default = _default;